import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChatOnboardingService {
  public endpointsAllowed: Array<string> = [
    '/trader',
    '/conta-aberta-trader',
    '/minha-conta/plataformas',
    '/explore-o-mercado'
  ];
  public endpointStartClosed: Array<string> = [
    '/minha-conta/plataformas',
  ]

  constructor() { }

  public activeService(url: string) {
    return this.endpointsAllowed.includes(url);
  }

  public closeOnSelectedPage(endpoint: string) {
    return this.endpointStartClosed.includes(endpoint);
  }

  public get isMobile(): boolean {
    return window.innerWidth <= 767;
  }

  public expirationCookie(time: string = 'YEARLY'): Date {
    switch (time) {
      case 'DAILY':
        return new Date(new Date().getTime() + (1000 * 60 * 60 * 24));
      case 'MONTHLY':
        return new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 30));
      case 'YEARLY':
        return new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 365));
    }
  }
}
